import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { KYMW1300Component } from './kymw1300.component';
import { PlanGoodsLockService } from '../../../commons/kymw00/api-services/plan-goods-lock.service';
import { FileUploadService } from '../../../commons/kymw02/file-upload/file-upload.service';
import { KYMW0400Module } from '../../../commons/kymw04/kymw0400/kymw0400.module';
import { KYMW0500Module } from '../../../commons/kymw05/kymw0500/kymw0500.module';
import { KYMW0800Module } from '../../../commons/kymw08/kymw0800/kymw0800.module';
import { KYMW0900Module } from '../../../commons/kymw09/kymw0900/kymw0900.module';
import { KYMW0902Module } from '../../../commons/kymw09/kymw0902/kymw0902.module';
import { KYMW1301Module } from '../kymw1301/kymw1301.module';
import { KYMW1302Module } from '../kymw1302/kymw1302.module';
import { KYMW1304Module } from '../kymw1304/kymw1304.module';
import { KYMW1307Module } from '../kymw1307/kymw1307.module';
import { KYMW1308Module } from '../kymw1308/kymw1308.module';
import { KYMW1310Module } from '../kymw1310/kymw1310.module';
import { KYMW1311Module } from '../kymw1311/kymw1311.module';
import { KYMW1312Module } from '../kymw1312/kymw1312.module';
import { KYMW1317Module } from '../kymw1317/kymw1317.module';
import { KYMW1318Module } from '../kymw1318/kymw1318.module';
import { KYMW1319Module } from '../kymw1319/kymw1319.module';
import { KYMW1320Module } from '../kymw1320/kymw1320.module';
import { KYMW1321Module } from '../kymw1321/kymw1321.module';
import { KYMW2000Module } from '../../kymw20/kymw2000/kymw2000.module';

import { GetCatalogInfoService } from './api-services/get-catalog-info.service';
import { OutputSetPlanListService } from './api-services/output-set-plan-list.service';
import { OutputBundleMixMatchListService } from './api-services/output-bundle-mix-match-list.service';
import { OutputSpecConfirmListService } from './api-services/output-spec-confirm-list.service';
import { OutputSelectedListService } from './api-services/output-selected-list.service';
import { CheckRegistPlanService } from './api-services/check-regist-plan.service';
import { GetPlanNumListService } from './api-services/get-plan-num-list.service';
import { CheckDeletePlanService } from './api-services/check-delete-plan.service';
import { DeletePlanService } from './api-services/delete-plan.service';
import { UpdateNextGuideAutoService } from './api-services/update-next-guide-auto.service';
import { RegistPlanService } from './api-services/regist-plan.service';
import { RegistLockInfoCatalogService } from './api-services/regist-lock-info-catalog.service';
import { DeleteLockInfoCatalogService } from './api-services/delete-lock-info-catalog.service';
import { GetOrderNumQuotaDataService } from './api-services/get-order-num-quota-data.service';
import { GetPlanTargetListService } from './api-services/get-plan-target-list.service';
import { GetSelectedListService } from './api-services/get-selected-list.service';
import { UpdateNextGuideLumpService } from './api-services/update-next-guide-lump.service';
import { KYMW1300TargetListModule } from './kymw1300-target-list/kymw1300-target-list.module';
import { KYMW1300SelectedListModule } from './kymw1300-selected-list/kymw1300-selected-list.module';
import { UploadPlanGoodsCoopFileService } from './api-services/upload-plan-goods-coop-file-service';
import { UploadCoopFileService } from './api-services/upload-coop-file-service';
import { UploadProposalCarrotFileService } from './api-services/upload-proposal-carrot-file.service';
import { GetBundleCatalogRoundInfoListService  } from './api-services/get-bundle-catalog-round-info-list.service';
import { GetFeatureCodeListService } from './api-services/get-feature-code-list.service';
import { GetPlanGoodsMediumtService } from './api-services/get-plan-goods-medium.service';
import { GetDeletePlanGoodsInfoService } from '../kymw1318/api-services/get-delete-plan-goods-info';

/**
 * 商品企画マスタ画面 モジュール設定クラス
 *
 * @export KYMW1300Module
 * @class KYMW1300Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
    WjNavModule,
    KYMW1300SelectedListModule,
    KYMW1300TargetListModule,
    KYMW0400Module,
    KYMW0500Module,
    KYMW0800Module,
    KYMW0900Module,
    KYMW0902Module,
    KYMW1301Module,
    KYMW1302Module,
    KYMW1304Module,
    KYMW1307Module,
    KYMW1308Module,
    KYMW1310Module,
    KYMW1311Module,
    KYMW1312Module,
    KYMW1317Module,
    KYMW1318Module,
    KYMW1319Module,
    KYMW1320Module,
	KYMW1321Module,
    KYMW2000Module,
  ],
  declarations: [
    KYMW1300Component,
  ],
  providers: [
    PlanGoodsLockService,
    CheckDeletePlanService,
    CheckRegistPlanService,
    DeleteLockInfoCatalogService,
    DeletePlanService,
    FileUploadService,
    GetCatalogInfoService,
    GetPlanNumListService,
    GetPlanTargetListService,
    GetOrderNumQuotaDataService,
    GetSelectedListService,
    OutputBundleMixMatchListService,
    OutputSelectedListService,
    OutputSetPlanListService,
    OutputSpecConfirmListService,
    RegistLockInfoCatalogService,
    RegistPlanService,
    UpdateNextGuideAutoService,
    UpdateNextGuideLumpService,
    UploadPlanGoodsCoopFileService,
    UploadCoopFileService,
    UploadProposalCarrotFileService,
    GetBundleCatalogRoundInfoListService,
    GetFeatureCodeListService,
    GetPlanGoodsMediumtService,
    GetDeletePlanGoodsInfoService,
  ],
})
export class KYMW1300Module {
}
